import React from "react";

import UploadFiles from "../../_components/upload-files.component";

class Upload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            customer: '',
            partNo: '',
            partDesc: '',
            partWeight: 0,
            partRunnerWeight: 0,
            cycleTime: 0,
            MOQ: 0,
            qty: 0,
            rejectionRate: 0,
            mouldNo: '',
            mouldType: '',
            mouldLife: 0,
            mouldLifeAlert: 0,
            offset: 0,
            cavityNo: 0,
            machineTonnage: 0,
            process1: '',
            process2: '',
            process3: '',
            process4: '',
            process5: '',
            riskClass: 0,
            company: 0,
        }
    }

    upload(){

    }

    render() {
        return (
            <div className="container" style={{ width: "600px" }}>
              <div style={{ margin: "20px" }}>
                <h4>Upload File</h4>
              </div>
        
              <UploadFiles buttonMode={true} onUpload={this.upload.bind(this)}/>
            </div>
          );
    }
}
export { Upload };